/**
 * @generated SignedSource<<6dd1cedde9cf46e5b06e933704cf2d6b>>
 * @relayHash e71cc77f1aa79411f47c53c49cf46494
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/362.0.0-2022-04-25T22:46:06.901Z/subscribeUserMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditNewslettersInput = {
  userServiceId: string;
  emailToken?: string | null;
  promotional?: boolean | null;
  favoriteSearches?: boolean | null;
  favoriteDealers?: boolean | null;
  trade?: boolean | null;
  smsOptin?: boolean | null;
  orderFeedbackMailOptin?: boolean | null;
  clientMutationId?: string | null;
};
export type subscribeUserMutation$variables = {
  input: EditNewslettersInput;
};
export type subscribeUserMutation$data = {
  readonly editNewsletters: {
    readonly clientMutationId: string | null;
  } | null;
};
export type subscribeUserMutation = {
  variables: subscribeUserMutation$variables;
  response: subscribeUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditNewslettersPayload",
    "kind": "LinkedField",
    "name": "editNewsletters",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "subscribeUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "subscribeUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/362.0.0-2022-04-25T22:46:06.901Z/subscribeUserMutation",
    "metadata": {},
    "name": "subscribeUserMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c9543e77c781df16904396e3a1064187";

export default node;
